"use strict";
/*
 * Created on 27. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Abstraction of consumer (sink) with back pressure implemented by promise.
 * @author Stepan Mik
 */

var AsyncConsumer =
/*#__PURE__*/
function () {
  function AsyncConsumer() {
    _classCallCheck(this, AsyncConsumer);
  }

  _createClass(AsyncConsumer, [{
    key: "init",
    value: function init() {
      return Promise.resolve();
    }
  }, {
    key: "finalize",
    value: function finalize() {
      return Promise.resolve(undefined);
    }
  }, {
    key: "consumeMany",
    value: function () {
      var _consumeMany = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(iterable) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, el, p;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 3;
                _iterator = iterable[Symbol.iterator]();

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 14;
                  break;
                }

                el = _step.value;
                p = this.consume(el);

                if (!(p != null)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 11;
                return p;

              case 11:
                _iteratorNormalCompletion = true;
                _context.next = 5;
                break;

              case 14:
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](3);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 20:
                _context.prev = 20;
                _context.prev = 21;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 23:
                _context.prev = 23;

                if (!_didIteratorError) {
                  _context.next = 26;
                  break;
                }

                throw _iteratorError;

              case 26:
                return _context.finish(23);

              case 27:
                return _context.finish(20);

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 16, 20, 28], [21,, 23, 27]]);
      }));

      return function consumeMany(_x) {
        return _consumeMany.apply(this, arguments);
      };
    }()
    /**
     * Wraps provided consumer into consumer that forwards only calls to #consume. Calls to other
     * lifecycle methods are discarded.
     * @param consumer consumer to be inhibited
     */

  }], [{
    key: "inhibit",
    value: function inhibit(consumer) {
      // tslint:disable-next-line:max-classes-per-file
      return new (
      /*#__PURE__*/
      function (_AsyncConsumer) {
        _inherits(_class, _AsyncConsumer);

        function _class() {
          _classCallCheck(this, _class);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
        }

        _createClass(_class, [{
          key: "consume",
          value: function consume(value) {
            return consumer.consume(value);
          }
        }]);

        return _class;
      }(AsyncConsumer))();
    }
  }, {
    key: "fromFunction",
    value: function fromFunction(consumer) {
      // tslint:disable-next-line:max-classes-per-file
      return new (
      /*#__PURE__*/
      function (_AsyncConsumer2) {
        _inherits(_class2, _AsyncConsumer2);

        function _class2() {
          _classCallCheck(this, _class2);

          return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
        }

        _createClass(_class2, [{
          key: "consume",
          value: function consume(value) {
            consumer(value);
            return null;
          }
        }]);

        return _class2;
      }(AsyncConsumer))();
    }
  }]);

  return AsyncConsumer;
}();

exports.AsyncConsumer = AsyncConsumer;